import { useState } from "react";
import type { CompanyProcess } from "@companyProcess/types/companyProcess";
import { useFindLogsQuery } from "@companyProcess/services/companyProcessService";
import { useCompanyLogsProps } from "./types";

const useCompanyLogs = ({setIsLogsOpen}: useCompanyLogsProps) => {

    const [selectedProceso, setSelectedProceso] = useState<CompanyProcess | undefined>(undefined);
    const {data: Logs} = useFindLogsQuery(selectedProceso?.publicId ?? '', {skip: !selectedProceso})

    const logButtonClicked = (item: CompanyProcess) => {
        setSelectedProceso(item)
        setIsLogsOpen()
    }

    return {
        Logs,
        logButtonClicked
    }
}

export default useCompanyLogs;